import axios, { AxiosRequestConfig } from 'axios';
import { API_BASE_URL } from '@/constants/config';

const defaultOptions: AxiosRequestConfig = {
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeoutErrorMessage: 'timeout error',
};

const isBrowserUserIdHeaderEnabled = false;

const createAxiosDefault = () => {
  const userBrowserId = localStorage.getItem('browserUserId');

  return {
    ...defaultOptions,
    headers: {
      ...defaultOptions.headers,
      'X-User-Id': isBrowserUserIdHeaderEnabled ? userBrowserId : undefined,
    },
  };
};

export const fetch = axios.create(createAxiosDefault());
